import React, { useState, useEffect } from "react";

import styles from "./index.module.css";
import ReportTableSessionAttendance from "Reporting/Components/ReportTableSessionAttendance";
import { useSessionAttendance } from "./useSessionAttendance";
import Loader from "shared/Loader";

export default function ReportTableListSessionAttendance({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);
  const [sortedReportsByTitle, setSortedReportsByTitle] = useState({});

  const { data, isLoading, isError, refetch } = useSessionAttendance(filters);

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger, refetch]);

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const groupedReports = data.map((item) => ({
      title: item.reportName,
      reports: Array.isArray(item.attendees) ? item.attendees : [],
    }));

    setReports(groupedReports);

    setSortedReportsByTitle((prev) => {
      const updated = {};
      groupedReports.forEach((r) => {
        updated[r.title] = r.reports;
      });
      return updated;
    });

    setReportsLength?.(groupedReports.length || 0);
  }, [data, setReportsLength]);

  const handleSortedReportsChange = (title, sorted) => {
    setSortedReportsByTitle((prev) => ({ ...prev, [title]: sorted }));
  };

  useEffect(() => {
    const arrayForPDF = Object.entries(sortedReportsByTitle).map(
      ([title, reports]) => ({
        title,
        reports,
      })
    );

    setReportData?.(arrayForPDF);
  }, [sortedReportsByTitle, setReportData]);

  if (isError) return <div>Something went wrong...</div>;
  if (isLoading) return <Loader />;
  if (reports.length === 0) return <div>No Reports Found</div>;

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <ReportTableSessionAttendance
          key={index}
          reports={report.reports}
          title={report.title}
          onSortedReportsChange={handleSortedReportsChange}
        />
      ))}
    </div>
  );
}
